// extracted by mini-css-extract-plugin
export default {"header":"NotificationPopOver-module__header--xz8Vb","title":"NotificationPopOver-module__title--UkhXd","markAll":"NotificationPopOver-module__markAll--ZwHBX"};